import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Calendar, User } from "lucide-react";
import SEOHead from "@/components/SEOHead";

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blogs").then((r) => setBlogs(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blogs-page">
      <SEOHead
        title="Health Blog | Diabetes, Thyroid, PCOS — Dr. Ashutosh Mishra"
        description="Science-backed health writing on diabetes, thyroid, PCOS, obesity, hormones and kidney protection by Dr. Ashutosh Mishra — Senior Diabetologist & Endocrinologist in Varanasi."
        path="/blog"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Blog", url: "/blog" },
        ]}
      />
      <section className="bg-gradient-to-br from-green-50/60 via-white to-green-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <nav className="text-xs text-slate-500 mb-3">
            <Link to="/" className="hover:text-green-700">Home</Link> <span className="mx-1.5">/</span> <span className="text-slate-700">Blog</span>
          </nav>
          <div className="text-xs uppercase tracking-[0.22em] text-green-700 font-medium">Health insights</div>
          <h1 className="font-poppins font-semibold text-4xl sm:text-5xl lg:text-6xl text-slate-900 mt-3 leading-tight">Health Blog</h1>
          <p className="text-slate-600 text-lg mt-4 max-w-3xl">
            Practical, science-backed health writing from Dr. Ashutosh Mishra — diabetes, thyroid, PCOS, obesity, hormones and kidney health, explained simply.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {loading ? (
          <div className="text-center text-slate-500 py-20">Loading articles...</div>
        ) : blogs.length === 0 ? (
          <div className="text-center text-slate-500 py-20">No articles yet.</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
            {blogs.map((b) => (
              <Link
                key={b.id}
                to={`/blog/${b.slug}`}
                data-testid={`blog-listing-${b.slug}`}
                className="group bg-white rounded-3xl border border-slate-100 overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase tracking-wider text-green-700 font-medium">{b.category}</div>
                  <h2 className="font-poppins font-semibold text-xl text-slate-900 mt-2 leading-snug">{b.title}</h2>
                  <p className="text-slate-600 text-sm mt-3 line-clamp-3 leading-relaxed">{b.excerpt}</p>
                  <div className="flex gap-4 items-center mt-5 text-xs text-slate-500">
                    <span className="inline-flex items-center gap-1"><User className="w-3.5 h-3.5" />{b.author}</span>
                    <span className="inline-flex items-center gap-1"><Calendar className="w-3.5 h-3.5" />{new Date(b.created_at).toLocaleDateString()}</span>
                    <span>{b.read_time}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
